import { IsString, IsNotEmpty, Length, IsNumberString } from 'class-validator';

import { SMS_CODE_LENGTH } from '../constants';

const notEmptyOptions = {
  message: 'Обязательное поле',
};

export class VerifyCodeDto {
  @IsNotEmpty({
    ...notEmptyOptions,
    groups: ['code-verify'],
  })
  @IsString({
    groups: ['code-verify'],
  })
  @Length(SMS_CODE_LENGTH, SMS_CODE_LENGTH, {
    message: 'Вы указали неверный код',
    groups: ['code-verify'],
  })
  @IsNumberString(
    {
      no_symbols: true,
    },
    {
      message: 'Вы указали неверный код',
      groups: ['code-verify'],
    },
  )
  code: string;
}
